module.exports = __webpack_public_path__ + "img/2025.e1a07632.png";